export type SignInReason = "unauthenticated" | "expired" | "server";

/**
 * Почему поверхность показывает вход.
 *
 * Кука живёт 30 суток, поэтому «сессия закончилась» и «сервер не ответил» — это разные новости,
 * и человек должен видеть, какая из них его. Список кодов один на все поверхности: иначе
 * менеджер и админка со временем начнут понимать одну и ту же ошибку по-разному.
 */
export function signInReasonFor(code: string | undefined): SignInReason {
  if (code === "session_expired" || code === "session_revoked") return "expired";
  if (code === "unauthenticated") return "unauthenticated";
  return "server";
}
